<template>
    <ol class="vet-breadcrumb">
        <li
            v-for="(item, index) in processedItems"
            :key="index"
            :class="{
                item: true,
                active: item.active
            }"
        >
            <template v-if="settingsCI(item)">
                <router-link
                    v-if="isEnhancedLayout"
                    :to="getSettingsRoute(item)"
                    href="/view/settings-ci"
                >
                    {{ item.text }}
                </router-link>
                <a v-else :href="item.href">{{ item.text }}</a>
            </template>
            <router-link
                v-else-if="item.to && item.to !== '' && !item.active"
                :to="item.to"
            >
                {{ item.text }}
            </router-link>
            <a v-else-if="item.href && !item.active" :href="item.href">
                {{ item.text }}
            </a>
            <a v-else-if="!item.active" href="#" @click.prevent>
                {{ item.text }}
            </a>
            <span v-else>{{ item.text }}</span>
        </li>
    </ol>
</template>

<script>
export default {
    name: "vet-breadcrumb",
    props: {
        items: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
        processedItems() {
            let arr = this.items;
            let hasActiveItem = arr.find(item => item.active === true); // detect active

            if (!hasActiveItem && arr.length > 0) {
                arr[arr.length - 1].active = true;
            }

            return arr;
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    methods: {
        settingsCI(item) {
            if (
                item.href &&
                item.href.startsWith(process.env.APPS + "business/business")
            ) {
                return true;
            } else {
                return false;
            }
        },
        getSettingsRoute(item) {
            if (!item.href) return { name: "settings-ci" };

            const url = new URL(item.href, window.location.origin);
            const queryParams = Object.fromEntries(url.searchParams);

            return {
                name: "settings-ci",
                query: queryParams
            };
        }
    }
};
</script>

<style lang="scss" scoped>
$active_color_bc: #6c757d;

.vet-breadcrumb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: #e9ecef;
    border-radius: 0.25rem;

    .item:not(:first-child)::before {
        content: ">";
        color: $active_color_bc;
        padding-left: 0.6rem;
        padding-right: 0.2rem;
    }

    .item.active {
        color: $active_color_bc;
    }
}
</style>
